module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_vm._t("default"), _vm._v(" "), _c('div', {
    staticClass: "floor"
  }, [_c('h2', [_vm._v(_vm._s(_vm.dataForm.title))]), _vm._v(" "), _c('div', {
    staticClass: "floor-tabs"
  }, [_c('el-tabs', {
    attrs: {
      "type": "card"
    },
    model: {
      value: (_vm.dataForm.activeName),
      callback: function($$v) {
        _vm.$set(_vm.dataForm, "activeName", $$v)
      },
      expression: "dataForm.activeName"
    }
  }, _vm._l((_vm.dataForm.tabList), function(item, index) {
    return _c('el-tab-pane', {
      key: item.id,
      attrs: {
        "label": item.title,
        "name": index + ''
      }
    })
  }), 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "floor-box"
  }, [_c('div', {
    staticClass: "floor-left"
  }, [_c('div', {
    staticClass: "floor-left__top",
    style: ({
      background: _vm.dataForm.LeftBackgroundColor
    })
  }, [_c('el-row', {
    attrs: {
      "gutter": 3
    }
  }, _vm._l((_vm.dataForm.leftNavList), function(item) {
    return _c('el-col', {
      key: item.uuid,
      attrs: {
        "span": 8
      }
    }, [_c('div', {
      staticClass: "goods—type__link",
      style: ({
        color: _vm.dataForm.LeftFontColor
      })
    }, [_vm._v(_vm._s(item.titleName))])])
  }), 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "floor-left__footer"
  }, [_c('img', {
    attrs: {
      "src": _vm.dataForm.leftImg.url
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "floor-content"
  }, _vm._l((_vm.dataForm.tabList), function(items, index) {
    return _c('el-row', {
      key: items.uuid
    }, _vm._l((items.children), function(item) {
      return ((index + '') === _vm.dataForm.activeName) ? _c('el-col', {
        key: item.id,
        attrs: {
          "span": 6
        }
      }, [_c('div', {
        staticClass: "floor-content__goods"
      }, [_c('el-image', {
        staticStyle: {
          "width": "100%",
          "height": "170px"
        },
        attrs: {
          "src": item.pics[0],
          "fit": "cover"
        }
      }), _vm._v(" "), _c('p', [_vm._v(_vm._s(_vm._f("titlefilter")(item.item_name)))]), _vm._v(" "), _c('div', {
        staticClass: "content-goods__footer"
      }, [_c('div', {
        staticClass: "goods-footer__price"
      }, [_c('p', [_vm._v(_vm._s(_vm._f("price")(item.price)))])]), _vm._v(" "), _c('div', {
        staticClass: "goods-footer__submit"
      }, [_c('el-button', {
        attrs: {
          "size": "mini",
          "type": "danger"
        }
      }, [_vm._v("加入购物车")])], 1)])], 1)]) : _vm._e()
    }), 1)
  }), 1), _vm._v(" "), _c('div', {
    staticClass: "floor-right"
  }, [_c('div', {
    staticClass: "floor-right__top"
  }, [_c('img', {
    attrs: {
      "src": _vm.dataForm.rightImg1.url
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "floor-right__footer"
  }, [_c('img', {
    attrs: {
      "src": _vm.dataForm.rightImg2.url
    }
  })])])])])], 2)
},staticRenderFns: []}
module.exports.render._withStripped = true
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-165c2f9f", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-165c2f9f"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/view/pc/homePage/components/plugins/floor/index.vue
// module id = 2493
// module chunks = 0